import React from "react";

/**
 * Всплывающая подсказка над кнопкой ассистента: один готовый вопрос.
 *
 * Props:
 *   text      — вопрос
 *   onAsk()   — клик по вопросу (открыть панель и задать его)
 *   onDismiss() — закрыть
 */
export default function AssistantTeaser({ text, onAsk, onDismiss }) {
  return (
    <div style={styles.wrap}>
      <button type="button" style={styles.close} onClick={onDismiss} title="Скрыть">
        ✕
      </button>
      <div style={styles.hint}>Спросите ассистента:</div>
      <button type="button" style={styles.question} onClick={onAsk}>
        {text}
      </button>
    </div>
  );
}

const styles = {
  wrap: {
    position: "fixed",
    right: 24,
    bottom: 88, // над FAB (52px + отступ)
    zIndex: 1000,
    maxWidth: 260,
    padding: "10px 12px",
    borderRadius: 12,
    background: "var(--c-card)",
    border: "1px solid var(--c-border)",
    boxShadow: "0 8px 28px rgba(0,0,0,0.35)",
  },
  close: {
    position: "absolute",
    top: 4,
    right: 6,
    border: "none",
    background: "transparent",
    color: "var(--c-text-sub)",
    fontSize: 14,
    cursor: "pointer",
    lineHeight: 1,
    padding: 2,
  },
  hint: {
    fontSize: 13,
    color: "var(--c-text-sub)",
    marginBottom: 6,
    paddingRight: 14,
  },
  question: {
    display: "block",
    width: "100%",
    textAlign: "left",
    border: "none",
    background: "transparent",
    padding: 0,
    color: "var(--c-accent)",
    fontSize: 15,
    fontWeight: 600,
    cursor: "pointer",
  },
};
